import { useDispatch } from 'react-redux';
import Icon, { COLORS, ICONS } from '../../../../../../general-ui/icon';
import { setPanelOpen } from '../../../../../../../store/actions/admin/event-panel';
import Switch from '../../../../../../general-ui/switch/switch';

interface IPanelHeaderProps {
	title: string;
	// include toggle with provided function
	useToggle?: { value: string, handleClick: () => void, on: boolean; };
	// header style changes if there is a tabbed menu below
}

const PanelHeader: React.FC<IPanelHeaderProps> = ({ title, useToggle, children }): JSX.Element => {
	const dispatch = useDispatch();

	return (
		<div className="panel-header">
			<div className="title">
				<h6>{title}</h6>
				<div className="buttons">
					{useToggle && (<Switch
						value={useToggle.value}
						on={useToggle.on}
						onClick={useToggle.handleClick}
					/>)}
					<button className='no-style' onClick={() => dispatch(setPanelOpen(false))}>
						<Icon name={ICONS.CLOSE} size={16} color={COLORS.DEFAULT_GRAY} />
					</button>
				</div>
			</div>
			{children && <div className="tabs-container">
				{children}
			</div>}
		</div>

	);
};

export default PanelHeader;